/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum BulkTranslationTaskStatus {
    NotStarted = 'NotStarted',
    Processing = 'Processing',
    Complete = 'Complete',
    Error = 'Error'
}

export function BulkTranslationTaskStatusFromJSON(json: any): BulkTranslationTaskStatus {
    return BulkTranslationTaskStatusFromJSONTyped(json, false);
}

export function BulkTranslationTaskStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkTranslationTaskStatus {
    return json as BulkTranslationTaskStatus;
}

export function BulkTranslationTaskStatusToJSON(value?: BulkTranslationTaskStatus | null): any {
    return value as any;
}

